import { useState, useEffect } from 'react';

import { urlApi } from '../helpers/functionHelpers';
import '../styles/DocumentViewer.css';

const DocumentViewer = ({ folio }) => {
  const [documentos, setDocumentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  useEffect(() => {
    if (!folio) return;
    fetchDocumentos();
  }, [folio]);

  const fetchDocumentos = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${urlApi}/api/documentos/lista/${folio}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Error al cargar documentos');
      }

      const data = await response.json();
      setDocumentos(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (tipoDocumento) => {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(
        `${urlApi}/api/documentos/descargar/${folio}/${tipoDocumento}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (!response.ok) {
        throw new Error('Error al descargar documento');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = tipoDocumento + '.pdf';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      setError(err.message);
      console.error('Error:', err);
    }
  };

  const handleViewPdf = async (tipoDocumento, nombreDocumento) => {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(
        `${urlApi}/api/documentos/descargar/${folio}/${tipoDocumento}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (!response.ok) {
        throw new Error('Error al cargar el documento');
      }

      const blob = await response.blob();
      
      // Convertir Blob a Data URL para evitar descarga
      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = reader.result;
        setSelectedDoc(nombreDocumento);
        setPdfUrl(dataUrl);
      };
      reader.readAsDataURL(blob);
    } catch (err) {
      setError(err.message);
      console.error('Error:', err);
    }
  };

  const closePdfModal = () => {
    setSelectedDoc(null);
    setPdfUrl(null);
  };

  if (loading) return <p>Cargando documentos...</p>;

  if (!documentos.length) {
    return <p>No hay documentos adjuntos para esta reservación</p>;
  }

  const tiposDocumento = {
    'oc': 'Orden de Compra',
    'factura': 'Factura',
    'certificado': 'Certificado',
    'otros': 'Otros'
  };

  return (
    <div className="document-viewer">
      <h3>Documentos Adjuntos</h3>
      <div className="documents-list">
        {documentos.map((doc) => (
          <div key={doc.id} className="document-item">
            <div className="document-info">
              <span className="document-type">
                {tiposDocumento[doc.tipo_documento] || doc.tipo_documento}
              </span>
              <span className="document-date">
                {new Date(doc.fecha_carga).toLocaleDateString('es-MX')}
              </span>
            </div>
            <div className="document-buttons">
              <button
                className="view-button"
                onClick={() => handleViewPdf(doc.tipo_documento, tiposDocumento[doc.tipo_documento] || doc.tipo_documento)}
              >
                Ver
              </button>
              <button
                className="download-button"
                onClick={() => handleDownload(doc.tipo_documento)}
              >
                Descargar
              </button>
            </div>
          </div>
        ))}
      </div>
      {error && <p className="error-message">{error}</p>}

      {/* Modal para ver PDF */}
      {selectedDoc && pdfUrl && (
        <div className="pdf-modal-overlay" onClick={closePdfModal}>
          <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="pdf-modal-header">
              <h3>{selectedDoc}</h3>
              <button className="pdf-modal-close" onClick={closePdfModal}>
                ✕
              </button>
            </div>
            <div className="pdf-modal-body">
              <iframe
                src={pdfUrl}
                title="PDF Viewer"
                className="pdf-iframe"
                style={{ display: 'block' }}
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentViewer;
